<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :back="true" back-component-name="management.supplier_companies.index">
        <template v-slot:title>
          <span>{{ $t("supplier_companies.users") }}</span>
        </template>
        <template v-slot:preview>
          <b-row>
            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('supplier_companies.name')">
                <b-form-input
                    v-model="form.name"
                    :placeholder="$t('supplier_companies.name')"
                    :state="validateState('name')"
                    class="form-control form-control-solid"
                    name="name"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('name') && !$v.form.name.required"
                    :state="!(validateState('name') && !$v.form.name.required)">
                  {{ $t('supplier_companies.validations.name.required') }}
                </b-form-invalid-feedback>
              </b-form-group>

            </b-col>
            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('supplier_companies.description')">
                <b-form-input
                    v-model="form.description"
                    :placeholder="$t('supplier_companies.description')"
                    class="form-control form-control-solid"
                    :state="validateState('description')"
                    name="description"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('description') && !$v.form.description.required"
                    :state="!(validateState('description') && !$v.form.description.required)">
                  {{ $t('supplier_companies.validations.description.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('supplier_companies.phone_number')">
                <b-form-input
                    v-model="form.phone_number"
                    :placeholder="$t('supplier_companies.phone_number')"
                    :state="validateState('phone_number')"
                    class="form-control form-control-solid"
                    name="name"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('phone_number') && !$v.form.phone_number.required"
                    :state="!(validateState('phone_number') && !$v.form.phone_number.required)">
                  {{ $t('supplier_companies.validations.phone_number.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('supplier_companies.city')">
                <multiple-select-input
                    :model.sync="form.city_id"
                    :values="cities"
                    :multiple="false"
                    :show-error="!validateState('city_id') && !$v.form.city_id.required"
                    :state="validateState('city_id') && $v.form.city_id.required"
                ></multiple-select-input>
                <b-form-invalid-feedback
                    v-if="!validateState('city_id') && !$v.form.city_id.required"
                    :state="validateState('city_id') && $v.form.city_id.required">
                  {{ $t('supplier_companies.validations.city.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('supplier_companies.county')">
                <multiple-select-input
                    :disabled="!form.city_id"
                    :model.sync="form.county_id"
                    :values="counties"
                    :multiple="false"
                    :show-error="!validateState('county_id') && !$v.form.county_id.required"
                    :state="validateState('county_id') && $v.form.county_id.required"
                ></multiple-select-input>
                <b-form-invalid-feedback
                    v-if="!validateState('county_id') && !$v.form.county_id.required"
                    :state="validateState('county_id') && $v.form.county_id.required">
                  {{ $t('supplier_companies.validations.county.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('supplier_companies.address')">
                <b-form-input
                    v-model="form.address"
                    :placeholder="$t('supplier_companies.address')"
                    class="form-control form-control-solid"
                    :state="validateState('address')"
                    name="address"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('address') && !$v.form.address.required"
                    :state="!(validateState('address') && !$v.form.address.required)">
                  {{ $t('supplier_companies.validations.address.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="2" md="6" sm="12" xl="2">
              <b-form-group :label="$t('supplier_companies.status')">
                <b-form-checkbox v-model="form.status" name="check-button" switch>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col
                class="float-right text-right"
                lg="12"
                md="12"
                sm="12"
                xl="12"
            >
              <b-button
                  class="mr-1"
                  variant="secondary"
                  @click="goBack"
              >
                <i class="fas fa-arrow-left"></i>
                {{ $t("general.cancel") }}
              </b-button>
              <b-button variant="primary" @click="createOrUpdate()">
                <i class="far fa-save"></i>
                {{ $t(id != null ? "general.save" : "general.create") }}
              </b-button>
            </b-col>
          </b-row>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>
<script>
import DashboardBox from "@/assets/components/DashboardBox";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

import baseModule, {
  BASE_URL,
  CREATE_ITEM,
  ERROR,
  GET_ITEM,
  ITEM,
  LOADING,
  MODULE_NAME,
  SUCCESS,
  UPDATE_ITEM
} from "@/core/services/store/supplierCompany.module";

import cityModule, {
  ITEMS_ALL as CITY_ITEMS,
  MODULE_NAME as CITY_MODULE_NAME,
  GET_ALL_ITEMS as GET_CITY_ITEMS
} from "@/core/services/store/city.module";

import countyModule, {
  ITEMS_ALL as COUNTY_ITEMS,
  MODULE_NAME as COUNTY_MODULE,
  GET_ALL_ITEMS as GET_COUNTY_ITEMS
} from "@/core/services/store/county.module";

import store from "@/core/services/store";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import _ from "lodash";

const _MODULE_NAME = MODULE_NAME;
const _CITY_MODULE_NAME = CITY_MODULE_NAME;
const _COUNTY_MODULE = COUNTY_MODULE;

export default {
  name: "SupplierCompanyCreateEdit",
  mixins: [validationMixin],
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, baseModule);
    registerStoreModule(_CITY_MODULE_NAME, cityModule);
    registerStoreModule(_COUNTY_MODULE, countyModule);
  },
  components: {
    DashboardBox,
    MultipleSelectInput
  },
  validations: {
    form: {
      name: {
        required
      },
      description: {
        required
      },
      phone_number: {
        required
      },
      city_id: {
        required
      },
      county_id: {
        required
      },
      address: {
        required
      },
      status: {
        required
      }
    }
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    item() {
      return store.getters[_MODULE_NAME + "/" + ITEM];
    },
    cities() {
      return store.getters[_CITY_MODULE_NAME + "/" + CITY_ITEMS] || [];
    },
    counties() {
      return store.getters[_COUNTY_MODULE + "/" + COUNTY_ITEMS] || [];
    }
  },
  data() {
    return {
      id: this.$route.params.id,
      form: {
        name: null,
        description: null,
        institution_id: null,
        city_id: null,
        county_id: null,
        address: null,
        phone_number: null,
        status: true
      }
    };
  },
  methods: {
    goBack() {
      this.$router.push({name: "management.supplier_companies"})
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    getItem() {
      this.$store
          .dispatch(_MODULE_NAME + "/" + GET_ITEM, {
            url: BASE_URL + "/" + this.id,
          })
    },
    getCities() {
      this.$store
          .dispatch(_CITY_MODULE_NAME + "/" + GET_CITY_ITEMS, {})
    },
    getCounties() {
      let filter = {
        city_id: this.form.city_id
      }
      this.$store
          .dispatch(_COUNTY_MODULE + "/" + GET_COUNTY_ITEMS, {
            filters: filter,
          })
    },
    createOrUpdate() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      let formData = _.clone(this.form);
      if (this.form.status) {
        formData.status = 1;
      } else {
        formData.status = 0;
      }

      if (this.id) {
        this.$store
            .dispatch(_MODULE_NAME + "/" + UPDATE_ITEM, {
              url: BASE_URL + "/" + this.id,
              contents: formData
            });
      } else {
        this.$store
            .dispatch(_MODULE_NAME + "/" + CREATE_ITEM, {
              url: BASE_URL,
              contents: formData,
            });
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.$t("general.dashboard"), route: "dashboard"},
      {title: this.$t(this.id ? "supplier_companies.edit_item" : "supplier_companies.create_item")}
    ]);

    if (this.cities && !this.cities.length) {
      this.getCities();
    }

    if (!this.counties && this.form.city_id) {
      this.getCounties();
    }

    if (this.id) {
      this.getItem();
    }
  },
  watch: {
    'form.city_id': {
      handler: function (newValue, oldValue) {
        if (newValue === undefined || oldValue === undefined) return;
        this.getCounties();
      }
    },
    cities: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue.length) {
            if (this.form.city_id && typeof this.form.city_id !== 'object') {
              this.form.city_id = this.cities.find(subItem => +subItem.id === +this.form.city_id).id;
            }
          }

        }
      }, deep: true
    },
    counties: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue.length) {
            if (this.form.county_id && typeof this.form.county_id !== 'object') {
              this.form.county_id = this.counties.find(subItem => +subItem.id === +this.form.county_id).id;
            }
          }
        }
      }, deep: true
    },
    item(value) {
      if (value) {
        let item = value.item;
        if (item.status) {
          item.status = true;
        } else {
          item.status = false;
        }

        this.form = item;
      }
    },
    success(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self.sweetAlertSuccess(self.$t("general.successfully_saved"),
              (response) => {
                if (response) {
                  self.$router.push({ name: "management.supplier_companies"});
                }
              });
        }, 500)
      }
    }
  }
};
</script>

<style scoped>
#dashboard-box {
  padding: 10px;
}
</style>
